//test
export default class morefun {
  getTag(tags) {
    var passTag = {}
    if (tags.length === 1 && tags[0].children !== undefined) {
      passTag.t1 = tags
      var next = tags[0].children
      if (next.length === 1 && next[0].children !== undefined) {
        passTag.t2 = next
        var next = next[0].children
        if (next.length === 1 && next[0].children !== undefined) {
          passTag.t3 = next
          var next = next[0].children
          if (next.length === 1 && next[0].children !== undefined) {
            passTag.t4 = next
            //add
            var next = next[0].children
            if (next.length === 1 && next[0].children !== undefined) {
              passTag.t5 = next
            } else{
              passTag.t5 = next
            }

          } else {
            passTag.t4 = next
            passTag.t5 = []
          }
        } else {
          passTag.t3 = next
          passTag.t4 = []
          passTag.t5 = []
        }
      } else {
        passTag.t2 = next
        passTag.t3 = []
        passTag.t4 = []
        passTag.t5 = []
      }
    } else {
      passTag.t1 = tags
      passTag.t2 = []
      passTag.t3 = []
      passTag.t4 = []
      passTag.t5 = []
    }
    //console.log(passTag)
    return passTag

  }

  getFormattedDate(date) {
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    return year + '-' + month + '-' + day;
  }

  getColumns() {
    let columns = {}
    //默认列名
    columns.default = ['chk', 'docid', 'fname', 'fcode', 'pdate', 'publisher', 'potence']
    //热点问题解答
    columns.jd = ['chk', 'docid', 'fname', 'pdate', 'psource', 'publisher']
    //涉税判例
    columns.case = ['chk', 'docid', 'fname', 'pdate', 'court', 'psource']
    //涉税报表
    columns.table = ['chk', 'docid', 'fname', 'fcode','fdown']
    //税务案例
    columns.taxcase = ['chk', 'docid', 'fname', 'pdate', 'author', 'reporter']
    //条约
    columns.treaty = ['chk', 'docid', 'fname', 'pdate', 'publisher', 'potence']
    columns.uploadfile = ['chk', 'fname', 'fcode', 'uploadtime', 'lastchangeeffectdate', 'lastchangeeffectstate', 'forcecount']
    return columns
  }

  deepCopy(p, c) {
    var c = c || {};
    for (var i in p) {
      if (typeof p[i] === 'object') {
        if (p[i] === null) {
          c[i] = null;
        } else {
          c[i] = (p[i].constructor === Array) ? [] : {};
          deepCopy(p[i], c[i]);
        }
      } else {
        c[i] = p[i];
      }
    }
    return c;
  }



}
